import { CONTRACTS, OPEN_COLLECTION_ID } from "./constants.js";
import { writable } from "svelte/store";
// import embedUrl from "../embed.js?url";
// const embedUrl = "/embed.js";
// console.log(embedUrl);
function loadCSS(url) {
  return new Promise((resolve, reject) => {
    var head = document.querySelector("head");
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = url;
    link.media = "all";
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Could not load CSS stylesheet`));
    head.appendChild(link);
  });
}

function loadJS(url, { type = "module" } = {}) {
  return new Promise((resolve, reject) => {
    var script = document.createElement("script");
    script.type = type;
    script.crossOrigin = "true";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Could not load JS script`));
    script.setAttribute("id", "highlight-embed-script");
    script.setAttribute("data-embed-version", "2.0");
    script.src = url;
    document.body.appendChild(script);
  });
}

let loadPromise;

export const userState = writable(null);
export const pendingMints = writable([]);
export const currentMintData = writable(null);

pendingMints.subscribe((list) => {
  console.log("Pending Mints:", list.length);
});

// window.addEventListener("highlight:minted", (event) => {
//   console.log("Minted!");
//   console.log(event.detail);
// });

// window.addEventListener("highlight:token-revealed", (event) => {
//   console.log("Reveal!");
//   console.log(event.detail);
// });

window.addEventListener("highlight:sign-in", (event) => {
  console.log("Signed in", event.detail);
  userState.update(() => ({ ...event.detail }));
});

window.addEventListener("highlight:sign-out", (event) => {
  console.log("Signed out");
  userState.update(() => null);
});

window.addEventListener("highlight:mint-initiated", (event) => {
  const txHash = event.detail.txHash;
  pendingMints.update((list) => {
    list = list.slice();
    if (!list.includes(txHash)) list.push(txHash);
    return list;
  });
});

window.addEventListener("highlight:minted", (event) => {
  const txHash = event.detail.txHash;
  pendingMints.update((list) => {
    list = list.slice();
    const idx = list.indexOf(txHash);
    if (idx >= 0) {
      list.splice(idx, 1);
    }
    return list;
  });
});

window.addEventListener("highlight:seed-refresh-finished", (ev) => {
  console.log("Seed Refreshed", ev.detail);
});

export const signInButton = (() => {
  const button = document.createElement("div");
  button.classList.add("connect-button");
  button.setAttribute("data-widget", "highlight-connect-wallet");
  detach();

  function detach() {
    if (button.parentElement) button.parentElement.removeChild(button);
    document.body.appendChild(button);
    button.style.position = "absolute";
    button.style.top = "0";
    button.style.left = "0";
    button.style.display = "none";
  }

  function attach(parent) {
    if (button.parentElement) button.parentElement.removeChild(button);
    button.style.position = "";
    button.style.top = "";
    button.style.left = "";
    button.style.display = "";
    parent.appendChild(button);
  }

  return { detach, attach, button };
})();

export const mintButton = (() => {
  const mintCard = document.createElement("div");
  mintCard.setAttribute("data-widget", "highlight-mint-card");
  mintCard.setAttribute("data-mint-collection-id", OPEN_COLLECTION_ID);
  mintCard.setAttribute("data-hide-success-modal", "true");
  mintCard.setAttribute(
    "data-theme",
    `{"bgColor":"#ffffff","textColor":"#000000","accentColor":"#000000","fontFamily":"inherit"}`
  );
  mintCard.setAttribute("data-template", "button-only");
  detach();

  function detach() {
    if (mintCard.parentElement) mintCard.parentElement.removeChild(mintCard);
    document.body.appendChild(mintCard);
    mintCard.style.position = "absolute";
    mintCard.style.top = "0";
    mintCard.style.left = "0";
    mintCard.style.display = "none";
  }

  function attach(parent) {
    if (mintCard.parentElement) mintCard.parentElement.removeChild(mintCard);
    mintCard.style.position = "";
    mintCard.style.top = "";
    mintCard.style.left = "";
    mintCard.style.display = "";
    parent.appendChild(mintCard);
  }

  return { detach, attach, button: mintCard };
})();

export const refreshButton = (() => {
  let refreshCard = null;

  function lazyCreate() {
    if (refreshCard) return refreshCard;
    refreshCard = document.createElement("div");
    refreshCard.setAttribute("data-widget", "highlight-seed-refresh-button");
    refreshCard.setAttribute(
      "data-mint-collection-id",
      CONTRACTS.NFT_LIMITED.id
    );
    // refreshCard.setAttribute("data-hide-success-modal", "true");
    refreshCard.setAttribute(
      "data-theme",
      `{"bgColor":"#ffffff","textColor":"#000000","accentColor":"#000000","fontFamily":"inherit"}`
    );
    // refreshCard.setAttribute("data-template", "button-only");
    detach();
    return refreshCard;
  }

  function destroy() {
    if (refreshCard && refreshCard.parentElement)
      refreshCard.parentElement.removeChild(refreshCard);
    refreshCard = null;
  }

  function detach() {
    lazyCreate();
    if (refreshCard && refreshCard.parentElement)
      refreshCard.parentElement.removeChild(refreshCard);
    document.body.appendChild(refreshCard);
    refreshCard.style.position = "absolute";
    refreshCard.style.top = "0";
    refreshCard.style.left = "0";
    refreshCard.style.display = "none";
  }

  function attach(parent) {
    lazyCreate();
    if (refreshCard && refreshCard.parentElement)
      refreshCard.parentElement.removeChild(refreshCard);
    refreshCard.style.position = "";
    refreshCard.style.top = "";
    refreshCard.style.left = "";
    refreshCard.style.display = "";
    parent.appendChild(refreshCard);
  }

  return { init: lazyCreate, detach, attach, destroy };
})();

async function load() {
  await Promise.all([
    loadCSS("https://mint.highlight.xyz/assets/embed.css"),
    loadJS("https://mint.highlight.xyz/assets/embed.js?v=1"),
  ]);
}

export function loadHighlight() {
  if (!loadPromise) loadPromise = load();
  return loadPromise;
}
